import { Observable } from "rxjs";

export abstract class LoginService {
  abstract setup(): void;

  abstract logout(): Observable<void>;

  abstract updateSessionWithTokenInformationIfExists(): void;

  abstract editProfile(): void;

  abstract resetPassword(loginHint?: string, state?: string): void;

  abstract manageTotp(loginHint?: string): void;

  abstract manageWebAuthn(): void;

  abstract login(loginHint?: string, state?: string, prompt?: string): void;
}
